"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { DNSChecking: false };
        fhandler.bind(this);
    },
    onInput: function (input) {
        input.reset && fhandler.reset();
    },
    onPrev: function () {
        this.emit('prev', this.input.index);
    },
    onNext: function () {
        const Form = this.state.form;
        if (!Form.subdomain)
            return this.state.formError.subdomain = true;
        else if (this.state.formError.subdomain)
            return;
        this.emit('next', this.input.index, Form);
    },
    checkDomain: async function () {
        if (this.state.form.subdomain.length < 3)
            return;
        try {
            const {error, message, exist} = await Request('/institution/domain/check?checkfor=' + this.state.form.subdomain);
            fhandler.error('subdomain', error ? 'Unexpected error occured. Try again' : exist ? 'This domain already exist' : false);
        } catch (error) {
            fhandler.error('subdomain', error);
        }
    },
    DNSLookup: function () {
        if (!this.state.form.custom_domain)
            return;
        this.state.DNSChecking = true;
        $.get('/lookup?hostname=' + this.state.form.custom_domain).done(response => fhandler.error('custom_domain', false)).fail(error => fhandler.error('custom_domain', Locale('This domain seems not to be available. Never mind, you can still set it later'))).always(() => this.state.DNSChecking = false);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Domains.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "w-100 p-lg-5 p-2"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("7683b9"),
    marko_node0 = marko_createElement("img", {
        src: "/images/icons/domain.png",
        alt: "institution",
        width: "60",
        "class": "mr-4"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "font-medium-2 mb-2"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_node3 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "font-medium-2 mb-2"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_node6 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("br", null, "33", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "font-medium-2 mb-2"
      },
    marko_attrs8 = {
        "class": "form-group"
      },
    marko_attrs9 = {
        "class": "font-small-4"
      },
    marko_node9 = marko_createElement("i", {
        "class": "bx bx-info-circle font-large-2 text-muted float-left mr-2 mb-2"
      }, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node10 = marko_createElement("br", null, "43", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node11 = marko_createElement("br", null, "44", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "navigation-buttons"
      },
    marko_attrs11 = {
        "class": "btn btn-outline-primary btn-xl text-left d-inline-block"
      },
    marko_attrs12 = {
        "class": "col pr-25"
      },
    marko_attrs13 = {
        "class": "col-4 pl-0"
      },
    marko_attrs14 = {
        "class": "font-medium-4"
      },
    marko_node12 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs15 = {
        cass: "d-flex align-items-center"
      },
    marko_node13 = marko_createElement("span", {
        "class": "text-muted small"
      }, "28", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Checking ...");

const fhandler = new FormHandler({ key: 'domains', autosave: true });

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("h5", marko_attrs2, "3", component);

        out.n(marko_node0, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("How will the world reach the institution?");
            }
          }, out, __component, "5");

        out.ee();

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        out.be("p", marko_attrs3, "8", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Choose a dedicated domain for your institution");
            }
          }, out, __component, "9");

        out.ee();

        out.be("div", marko_attrs4, "10", component);

        out.e("div", {
            "class": marko_classValue("form-row d-flex align-items-center rounded " + (state.activeInput ? "shadow" : "border"))
          }, "11", component, 2, 1)
          .e("div", marko_attrs12, "12", component, 1)
            .e("input", {
                id: "search-input",
                "class": "form-control form-control-xl font-medium-4 text-right border-none pr-0",
                placeholder: Locale("sub-domain"),
                required: true,
                name: "subdomain",
                value: state.form.subdomain,
                validate: fhandler.define({
                    name: "subdomain",
                    regexp: "/^[a-z_]+$/"
                  })
              }, "13", component, 0, 0, {
                oninput: __component.d("input", "__onInput", false),
                onchange: __component.d("change", "DNSLookup", false)
              })
          .e("div", marko_attrs13, "14", component, 1)
            .e("span", marko_attrs14, "15", component, 2)
              .t(".")
              .t(window.location.host.replace(window.Defaults.domainAddon + ".", ""), component);

        out.be("p", {
            "class": marko_classValue("small mt-50 mb-2" + (!state.formError.subdomain ? " d-none" : ""))
          }, "16", component, null, 1);

        Locale_tag({
            renderBody: function(out) {
              out.t((typeof state.formError.subdomain) == "string" ? state.formError.subdomain : "A domain is required for your institution", component);
            }
          }, out, __component, "17");

        out.ee();

        out.ee();

        out.n(marko_node3, component);

        out.n(marko_node4, component);

        out.n(marko_node5, component);

        out.be("p", marko_attrs5, "21", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Do you have a custom registered domain?");
            }
          }, out, __component, "22");

        out.ee();

        out.be("div", marko_attrs6, "23", component);

        out.e("input", {
            type: "text",
            value: state.form.custom_domain,
            name: "custom_domain",
            required: true,
            "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.custom_domain != undefined ? state.formError.custom_domain ? " is-invalid" : " is-valid" : "")),
            validate: fhandler.define("domain"),
            placeholder: Locale("www.example.com")
          }, "24", component, 0, 0, {
            oninput: __component.d("input", "__onInput", false),
            onchange: __component.d("change", "DNSLookup", false)
          });

        if (state.DNSChecking) {
          out.n(marko_node12, component);

          out.be("div", marko_attrs15, "26", component);

          Preloader_tag({
              class: "float-left font-medium-4 mr-2",
              active: true
            }, out, __component, "27");

          out.n(marko_node13, component);

          out.ee();
        }

        out.be("p", {
            "class": marko_classValue("small mt-50 mb-2" + (!state.formError.custom_domain ? " d-none" : ""))
          }, "29", component, null, 1);

        Locale_tag({
            renderBody: function(out) {
              out.t((typeof state.formError.custom_domain) == "string" ? state.formError.custom_domain : "Invalid Domain", component);
            }
          }, out, __component, "30");

        out.ee();

        out.ee();

        out.ee();

        out.n(marko_node6, component);

        out.n(marko_node7, component);

        out.n(marko_node8, component);

        out.be("p", marko_attrs7, "34", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Do you already have a website?");
            }
          }, out, __component, "35");

        out.ee();

        out.be("div", marko_attrs8, "36", component);

        out.e("input", {
            type: "text",
            value: state.form.website,
            name: "website",
            "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.website != undefined ? state.formError.website ? " is-invalid" : " is-valid" : "")),
            validate: fhandler.define("url"),
            placeholder: Locale("Website URL")
          }, "37", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        out.be("p", {
            "class": marko_classValue("small mt-50 mb-2" + (!state.formError.website ? " d-none" : ""))
          }, "38", component, null, 1);

        Locale_tag({
            text: "Invalid Website URL"
          }, out, __component, "39");

        out.ee();

        out.ee();

        out.be("p", marko_attrs9, "40", component);

        out.n(marko_node9, component);

        Locale_tag({
            renderBody: function(out) {
              out.t("If you don't have a website, a default website landing page will be generated just for your institution, ready to be customized.");
            }
          }, out, __component, "42");

        out.ee();

        out.n(marko_node10, component);

        out.n(marko_node11, component);

        out.be("div", marko_attrs10, "45", component);

        out.be("button", marko_attrs11, "46", component, null, 0, {
            onclick: __component.d("click", "onPrev", false)
          });

        Locale_tag({
            text: "Back",
            class: "px-3"
          }, out, __component, "47");

        out.ee();

        out.be("button", {
            disabled: !state.form.subdomain,
            "class": "btn btn-primary btn-xl text-left d-inline-block float-right w-50"
          }, "48", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "49");

        Locale_tag({
            text: "Continue"
          }, out, __component, "50");

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
